import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../shared/dataservice.service';
import { ChangeNoteMonthFilterDialog, ChangeNoteMonthFilterPayload } from '../../dialogs/change-note-month-filter-dialog/change-note-month-filter-dialog';

@Component({
  selector: 'app-kpi-excel',
  templateUrl: './kpi-excel.component.html',
  styleUrls: ['./kpi-excel.component.css']
})
export class KpiExcelComponent implements OnInit {
  constructor(private _dataService: DataService, private dialog: MatDialog, private cdr: ChangeDetectorRef) { }
  isLoading:boolean = false;
  ngOnInit() {
    // Defer page name change to next tick to avoid NG0100 error
    setTimeout(() => {
      this._dataService.currPageName = 'TPT + Downloads';
      this.cdr.markForCheck();
    }, 0);
  }
  downloadExcelTPT(isArchive:boolean) {
    if (isArchive == false) {
      let dialogRef = this.dialog.open(ChangeNoteMonthFilterDialog, {
        width: '50%',
        data: { reportName: 'TPT + Auto' }
      });

      dialogRef.afterClosed().subscribe((filterPayload: ChangeNoteMonthFilterPayload) => {
        if (filterPayload) {
          this._dataService.downloadFile('tptAuto', filterPayload);
        }
      });
    }
  }
  downloadExcelSAP(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('sap');
  }
  downloadExcelSAP2(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('sap2');
  }
}
